import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-payment-result-shopeepay',
  templateUrl: './payment-result-shopeepay.component.html',
  styleUrls: ['./payment-result-shopeepay.component.css']
})
export class PaymentResultShopeepayComponent implements OnInit {

  paymentResult;
  isSuccess;
  failedReason;
  invoiceNumber;
  transactionAmount;
  imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
  status;
  constructor(
      private router: Router
  ) {

    this.status = router.getCurrentNavigation().extras.state;
    this.invoiceNumber = this.status.payment.payment_reference_id;
    this.transactionAmount = this.status.payment.amount.toString();
  }

  ngOnInit(): void {

    if (this.status.data.status_payment === 'SUCCESS') {
      this.paymentResult = 'Success' ;
      this.failedReason = this.status?.data.message;
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/success.png';
      setTimeout(() => {
        window.location.href = this.status.returnUrl;
      }, 5000);
    } else if (this.status.data.status_payment === 'Failed') {
      this.paymentResult = this.status.data.status_payment;
      this.failedReason = this.status?.data.message;
      this.imageUrl = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/fail.png';
      setTimeout(() => {
        window.location.href = this.status.returnUrl;
      }, 5000);
    }
  }

}
